import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { TranslateService } from '@ngx-translate/core';
import { of, Subscription } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { ToastAction } from '@job-v2/ats-utils';
import {
  StatesService,
  StateStoreKeys,
  StorageData,
  WorkspaceService,
} from '@socium/sociumflow';
import { Applications } from '@socium/common-api';

@Component({
  imports: [RouterModule, ToastModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly primeNGConfig = inject(PrimeNG);
  private readonly translateServie = inject(TranslateService);
  private readonly workspaceService = inject(WorkspaceService);
  private readonly statesService = inject(StatesService);
  private authDataSubscription: Subscription | null = null;
  public isLoading = true;

  private subscription = new Subscription();

  ngOnInit(): void {
    this.primeNGConfig.ripple.set(true);
    this.setUpLanguageSettings();

    const authData = this.statesService.getCookie<StorageData>(
      StateStoreKeys.TOKEN_NAME,
    );

    this.authDataSubscription = of(authData).subscribe(
      (data: StorageData | null) => {
        if (data?._accessToken && data?._tokenExpirationDate) {
          this.workspaceService
            .setStatesStoreAfterReload(Applications.JOB)
            .then(() => {
              this.workspaceService.initCrossAppLogoutListener();
              this.workspaceService.processIntrospectToken();
              this.isLoading = false;
            })
            .catch((error) => {
              console.error('Error reloading state:', error);
              this.isLoading = false;
            });
          return;
        }

        this.isLoading = false;
      },
    );
  }
  ngOnDestroy(): void {
    this.authDataSubscription?.unsubscribe();
    this.subscription.unsubscribe();
  }

  setUpLanguageSettings() {
    this.translateServie.addLangs(['en', 'fr']);
    this.translateServie.setDefaultLang('fr');
    this.subscription = this.translateServie
      .stream('primeng')
      .subscribe((data) => {
        this.primeNGConfig.setTranslation(data);
      });
  }

  onToastAction(action: ToastAction, message: ToastMessageOptions): void {
    if (action.callback && typeof action.callback === 'function') {
      action.callback();
    }
    if (action.closeOnClick !== false) {
      const messageService = inject(MessageService);
      messageService.clear(message.key);
    }
  }

  title = 'job-ats';
}
